import { CustomerDocumentGateway } from './customer-document-gateway.interface';

const baseUrl = 'customer/documents';
export class HttpCustomerDocumentGateway implements CustomerDocumentGateway {
  private baseUrl = baseUrl;

  getCustomerDocumentsByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  postSingleDocument(args: {
    projectId: string;
    category: any;
    fileName: string;
    hiddenForCustomer: boolean;
    toBeSigned: boolean;
    fileContent: any;
  }) {
    const documents = [
      {
        category: args.category,
        fileName: args.fileName,
        hiddenForCustomer: args.hiddenForCustomer,
        toBeSigned: args.toBeSigned,
        fileContent: args.fileContent,
      },
    ];
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'POST',
      data: { documents },
    };
  }

  getDocumentById(args: { documentId: string }) {
    return { url: `${baseUrl}/${args.documentId}`, method: 'GET' };
  }

  getDocumentByprojectAndSlug(args: { projectId: string; slug: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/slug/${args.slug}`,
      method: 'GET',
    };
  }

  getDocumentBlobById(args: { documentId: string }) {
    return {
      url: `${baseUrl}/${args.documentId}/download`,
      method: 'GET',
      headers: { responseType: 'blob' },
    };
  }

  getDocumentCategories() {
    return { url: `${baseUrl}/categories`, method: 'GET' };
  }

  getStandardizedDocuments() {
    return { url: `${baseUrl}/standardized`, method: 'GET' };
  }

  // getDocumentById(projectId: string, documentId: string) {
  //   return {
  //     url: `${baseUrl}/${projectId}/document/${documentId}`,
  //     method: 'GET',
  //   };
  // }

  patchSignDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}/sign`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchDocument(args: { documentId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.documentId}`,
      method: 'PATCH',
      data: args.data,
    };
  }

  deleteDocument(args: { documentId: string }) {
    return { url: `${baseUrl}/${args.documentId}`, method: 'DELETE' };
  }

  // getDocumentBlob(documentId: string) {
  //   return {
  //     url: `${baseUrl}/${documentId}/download`,
  //     method: 'GET',
  //     headers: { responseType: 'blob' },
  //   };
  // }

  // getDocumentCategories() {
  //   return { url: `${baseUrl}/document-categories`, method: 'GET' };
  // }

  // getStandardizedDocuments() {
  //   return { url: `${baseUrl}/documents-standardized`, method: 'GET' };
  // }

  // patchSignDocument(documentId: string, data: any) {
  //   return { url: `${baseUrl}/documents/${documentId}/sign`, data };
  // }
}
